import { KSK2021_R01InspectDto } from './Dto_KSK2021_R01';

export interface AggregatedInspectBadQty {
	totalQty: number;
	minBadCaseQty: number;
	badCaseQtyMap: Map<string, number>;
}

/** badCase 기준으로 badQty를 합산해 집계한다. (동일 badCase는 합산) */
export const aggregateInspectListByBadCase = (
	inspectList: KSK2021_R01InspectDto[],
	deletedValueIndexes: number[] = [],
): AggregatedInspectBadQty => {
	const deletedIndexSet = new Set(deletedValueIndexes.map(value => Number(value)));
	const badCaseQtyMap = new Map<string, number>();

	inspectList
		.filter(inspect =>
			!deletedIndexSet.has(inspect.valueIndex) &&
			!!inspect.badCase
		)
		.forEach(item => {
			const qty = Number(item.badQty) || 0;
			badCaseQtyMap.set(item.badCase, (badCaseQtyMap.get(item.badCase) || 0) + qty);
		});

	const aggregatedQtyList = Array.from(badCaseQtyMap.values());
	const totalQty = aggregatedQtyList.reduce((sum, qty) => sum + qty, 0);
	const minBadCaseQty = aggregatedQtyList.length > 0
		? Math.min(...aggregatedQtyList)
		: 0;

	return { totalQty, minBadCaseQty, badCaseQtyMap };
};

export interface ValidateEditBadQtyResult {
	valid: boolean;
	message?: string;
}

/**
 * editKSK2021_R01.badQty가 badCase별 집계 수량 범위 내인지 검증한다.
 * - 최대: badQty는 집계 총수량(totalQty)을 초과할 수 없음
 * - 최소: badQty는 badCase별 집계 수량 중 최소값(minBadCaseQty)보다 작을 수 없음
 */
export const validateEditBadQtyAgainstInspectList = (
	editBadQty: number,
	inspectList: KSK2021_R01InspectDto[],
	deletedValueIndexes: number[] = [],
): ValidateEditBadQtyResult => {
	const { totalQty, minBadCaseQty, badCaseQtyMap } = aggregateInspectListByBadCase(
		inspectList,
		deletedValueIndexes,
	);

	if (badCaseQtyMap.size === 0) {
		return { valid: true };
	}

	if (editBadQty > totalQty) {
		return {
			valid: false,
			message: `불량수량은 불량내역 총수량(${totalQty})을 초과할 수 없습니다.`,
		};
	}

	if (editBadQty < minBadCaseQty) {
		return {
			valid: false,
			message: `불량수량은 불량내역 사유별 최소 수량(${minBadCaseQty})보다 작을 수 없습니다.`,
		};
	}

	return { valid: true };
};
